module.exports = __webpack_public_path__ + "img/FR.55df0a2e.svg";